<template>
  <div id="tete" class="user-nav">
    <ul class="user-nav__menu">
      <li v-has-feature="'Workspace'">
        <safe-with-else-router-link to="/workspace">
          <span class="user-nav__menu-item">
            <font-awesome-icon :icon="wrench"/> {{ $t('menu.workspace') }}
          </span>
          <span class="menu-item-disabled-fake" slot="else">
            <font-awesome-icon :icon="wrench"/> {{ $t('menu.workspace') }}
          </span>
        </safe-with-else-router-link>
      </li>
      <li>
        <safe-with-else-router-link to="/settings">
          <span class="user-nav__menu-item">
            <font-awesome-icon :icon="userCircle"/> {{ $t('menu.settings') }}
          </span>
          <span class="menu-item-disabled-fake" slot="else">
            <font-awesome-icon :icon="userCircle"/> {{ $t('menu.settings') }}
          </span>
        </safe-with-else-router-link>
      </li>
      <li>
        <div class="user-nav__menu-item">
          <font-awesome-icon :icon="globe"/>
          <span :class="getLangClass('en_GB')" v-on:click="changeLanguage('en_GB')">English</span>
          /
          <span :class="getLangClass('es_ES')" v-on:click="changeLanguage('es_ES')">{{ $t('menu.spanish') }}</span>
        </div>
      </li>
      <li v-if="hasUserManual()">
        <div class="user-nav__menu-item">
          <span v-on:click="openUserManual">
            <font-awesome-icon :icon="help" class="help_icon_hack"/><span class="help_icon_hack_text">{{ $t('menu.userManual') }}</span>
          </span>
        </div>
      </li>
      <li>
          <span v-on:click="doLogout" class="user-nav__menu-item">
            <font-awesome-icon :icon="signOutAlt"/> {{ $t('menu.logout') }}
          </span>
      </li>
    </ul>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faWrench, faGlobe, faQuestion } from '@fortawesome/fontawesome-free-solid';
import faSignOutAlt from '@fortawesome/fontawesome-free-solid/faSignOutAlt';
import faUserCircle from '@fortawesome/fontawesome-free-solid/faUserCircle';
import {mapActions, mapGetters} from 'vuex';
import config from 'BRAND/config';
import userManualApi from '@/api/userManual';
import SafeWithElseRouterLink from '@/components/shared/SafeWithElseRouterLink';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import 'dayjs/locale/en';

export default {
  components: {
    SafeWithElseRouterLink,
    FontAwesomeIcon
  },
  data () {
    return {
      activeLang: undefined
    };
  },
  computed: {
    wrench () {
      return faWrench;
    },
    globe () {
      return faGlobe;
    },
    help () {
      return faQuestion;
    },
    signOutAlt () {
      return faSignOutAlt;
    },
    userCircle () {
      return faUserCircle;
    },
    ...mapGetters([
      'getLocale',
      'getLanguageCode'
    ])
  },
  methods: {
    changeLanguage (locale) {
      this.setLocale({
        context: this,
        locale: locale
      });
      const languageCode = this.getLanguageCode;
      dayjs.locale(languageCode);
      this.activeLang = locale;
    },
    getLangClass (locale) {
      if (!this.activeLang) {
        this.activeLang = this.getLocale;
      }
      return this.activeLang === locale ? 'lang-active' : 'lang';
    },
    doLogout () {
      this.logout();
    },
    hasUserManual () {
      return (config.hasUserManual && config.hasUserManual === true);
    },
    openUserManual () {
      userManualApi.getPdfUserManual(this).then(pdf => {
        if (pdf.byteLength > 0) {
          const file = new Blob([pdf], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, 'icfc.pdf');
        }
      });
    },
    ...mapActions([
      'setLocale',
      'logout'
    ])
  }
};

</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";

  $padding-nav: $sp * 8;
  .user-nav {
    margin-top: $sp-margin;
    &__menu {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    &__menu-item {
      padding: $sp $padding-nav;
      display: block;
      color: $bodycolor-inverse;
      font-weight: 700;
      transition: 0.3s;
      &:hover,
      &:active {
        box-shadow: inset ($sp * 2) 0 0 $secondary-light2;
        color: $white-trans4;
        cursor: pointer;
      }
      &.is-active {
        background: $secondary;
        box-shadow: inset ($sp * 2) 0 0 $secondary-light2;
        &:hover {
          color: inherit;
        }
      }
    }
    .menu-item-disabled-fake {
      padding: $sp $padding-nav;
      display: block;
      color: $bodycolor-inverse;
      font-weight: 700;
      transition: 0.3s;
      //box-shadow: inset ($sp * 2) 0 0 $secondary-light2;
      color: $white-trans4;
    }
    .lang {
      color: $bodycolor-inverse;
    }
    .lang-active {
      font-weight: normal;
    }
  }

  // Needed because the help icon has different dimensions that the others
  .help_icon_hack {
    margin-left: 0.1em;
  }
  .help_icon_hack_text {
    margin-left: 0.45em;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/UserNav.vue